import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAreasAssigned = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 412,
	height: 142,
	viewBox: "0 0 412 142",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 282.93,
			y1: 130.444,
			x2: 206.93,
			y2: 118.444,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 55.4437,
			y2: -.45,
			transform: "matrix(0.991998 0.126254 0.126254 -0.991998 340 64)",
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 64.0078,
			y2: -.45,
			transform: "matrix(0.484316 -0.874893 -0.874893 -0.484316 297 127)",
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 56C336.418 56 340 59.5817 340 64C340 68.4183 336.418 72 332 72C327.582 72 324 68.4183 324 64C324 59.5817 327.582 56 332 56Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 61C333.657 61 335 62.3431 335 64C335 65.6569 333.657 67 332 67C330.343 67 329 65.6569 329 64C329 62.3431 330.343 61 332 61Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 64C407.418 64 411 67.5817 411 72C411 76.4183 407.418 80 403 80C398.582 80 395 76.4183 395 72C395 67.5817 398.582 64 403 64Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 69C404.657 69 406 70.3431 406 72C406 73.6569 404.657 75 403 75C401.343 75 400 73.6569 400 72C400 70.3431 401.343 69 403 69Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M292 125C296.418 125 300 128.582 300 133C300 137.418 296.418 141 292 141C287.582 141 284 137.418 284 133C284 128.582 287.582 125 292 125Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M292 130C293.657 130 295 131.343 295 133C295 134.657 293.657 136 292 136C290.343 136 289 134.657 289 133C289 131.343 290.343 130 292 130Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 127.393,
			y1: 74.5857,
			x2: 195.824,
			y2: 45.5857,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 72.0568,
			y1: 9.4464,
			x2: 17.0568,
			y2: 16.4464,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 114.606,
			y1: 72.2179,
			x2: 83.6063,
			y2: 16.2179,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80 1C75.5817 1 72 4.58172 72 9C72 13.4183 75.5817 17 80 17C84.4183 17 88 13.4183 88 9C88 4.58172 84.4183 1 80 1Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80 6C78.3431 6 77 7.34314 77 9C77 10.6569 78.3431 12 80 12C81.6569 12 83 10.6569 83 9C83 7.34314 81.6569 6 80 6Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 9C4.58172 9 1 12.5817 1 17C1 21.4183 4.58172 25 9 25C13.4183 25 17 21.4183 17 17C17 12.5817 13.4183 9 9 9Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 14C7.34315 14 6 15.3431 6 17C6 18.6569 7.34315 20 9 20C10.6569 20 12 18.6569 12 17C12 15.3431 10.6569 14 9 14Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120 70C115.582 70 112 73.5817 112 78C112 82.4183 115.582 86 120 86C124.418 86 128 82.4183 128 78C128 73.5817 124.418 70 120 70Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M120 75C118.343 75 117 76.3431 117 78C117 79.6569 118.343 81 120 81C121.657 81 123 79.6569 123 78C123 76.3431 121.657 75 120 75Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M359.3 94.65C359.3 96.67 357.67 98.3 355.65 98.3C353.63 98.3 352 96.67 352 94.65C352 92.63 353.63 91 355.65 91C357.67 91 359.3 92.63 359.3 94.65Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M43.2999 47.65C43.2999 49.67 41.6699 51.3 39.6499 51.3C37.6299 51.3 36 49.67 36 47.65C36 45.63 37.6299 44 39.6499 44C41.6699 44 43.2999 45.63 43.2999 47.65Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 153.487,
			y: 21.104,
			width: 91.5509,
			height: 121.65,
			rx: 6,
			transform: "rotate(-9.7415 153.487 21.104)",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 183.859,
			y: 20.5171,
			width: 69.3637,
			height: 97.5113,
			rx: 6,
			transform: "rotate(-0.454149 183.859 20.5171)",
			fill: "#E9EBF0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 202.132,
			y: 22.6706,
			width: 68.3637,
			height: 82.269,
			rx: 5.5,
			transform: "rotate(12.5804 202.132 22.6706)",
			fill: "white",
			stroke: "#E9EBF0"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M234.861 9.10272L218.237 12.3135L234.172 94.8149L243.407 93.0311L243.661 54.6632L243.661 54.6628L245.157 54.3738C248.41 53.7454 250.539 50.5984 249.91 47.3448L247.462 34.6696C246.92 31.8614 244.47 29.8264 241.61 29.8075L240.729 29.8017C240.333 29.7991 239.939 29.8355 239.551 29.9105L238.904 30.0355L234.861 9.10272Z",
			fill: "#E9EBF0"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 223.488,
			y1: 44.4929,
			x2: 257.172,
			y2: 51.6651,
			stroke: "#D9DEEB",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 214.82,
			y1: 50.7913,
			x2: 248.504,
			y2: 57.9634,
			stroke: "#D9DEEB",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149.07 22.3275C145.063 23.4352 142.715 27.58 143.822 31.5853L172.228 134.331C173.335 138.337 177.479 140.687 181.486 139.579L250.386 120.531C254.392 119.423 256.741 115.278 255.634 111.273L237.588 45.9988C241.594 44.8912 243.943 40.7463 242.835 36.7411L234.481 6.52161C233.373 2.51635 229.229 0.166403 225.223 1.27403L149.07 22.3275Z",
			fill: "#3085E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M239.856 92.2131L236.431 93.1599L236.226 93.2192C235.59 93.3827 235.429 93.6905 235.323 94.0447L233.777 98.9238L230.079 95.5841L229.956 95.475C229.956 95.475 229.853 95.3759 229.728 95.4056L229.728 95.4058C229.605 95.4444 229.568 95.5823 229.568 95.5823L229.519 95.7389L228.15 100.479L224.228 97.1119C223.955 96.8626 223.658 96.6814 223.029 96.8675L222.823 96.9222L219.397 97.8693L220.332 101.246L222.349 100.688C222.773 100.566 222.975 100.533 223.367 100.815L223.539 100.965L229.442 106.451C229.442 106.451 229.634 106.628 229.859 106.567C230.102 106.5 230.176 106.247 230.176 106.247L231.528 101.902L231.529 101.902L235.015 104.904C235.015 104.904 235.215 105.084 235.426 105.032C235.652 104.975 235.714 104.716 235.714 104.716L237.899 96.9952L237.968 96.7785C238.083 96.3825 238.336 96.2743 238.761 96.1613L240.78 95.6018L239.856 92.2131Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M237.293 103.026L236.097 107.243L232.092 103.771L230.855 107.767L237.513 113.963C237.729 114.126 237.867 114.134 237.931 114.119C238.072 114.087 238.131 113.987 238.208 113.685L239.924 105.872C240.08 105.192 240.617 105.051 240.617 105.051L243.216 104.333L242.281 100.961L238.224 102.083C237.486 102.287 237.293 103.026 237.293 103.026Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 162.191,
			y1: 35.15,
			x2: 213.301,
			y2: 21.02,
			stroke: "#006ADC",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 164.195,
			y1: 42.4009,
			x2: 191.13,
			y2: 34.9546,
			stroke: "#006ADC",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 166.198,
			y1: 49.6524,
			x2: 205.22,
			y2: 38.8642,
			stroke: "#006ADC",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 152.861,
			y1: 81.0978,
			x2: 163.694,
			y2: 120.108,
			stroke: "#002E5F",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.0426 101.173C50.8326 101.183 50.6226 101.133 50.4326 101.003C49.9826 100.693 49.8626 100.083 50.1726 99.6326L55.9326 91.1926C56.1026 90.9426 56.3826 90.7826 56.6826 90.7626C56.9626 90.7326 57.2826 90.8627 57.4826 91.0827L61.2026 95.1726L67.8726 84.1326C68.0326 83.8726 68.2926 83.7026 68.5926 83.6626C68.8926 83.6326 69.1926 83.7326 69.4126 83.9426L73.4626 87.9727L82.0126 75.4326C82.3226 74.9826 82.9326 74.8626 83.3826 75.1726C83.8326 75.4826 83.9527 76.0926 83.6427 76.5426L74.4326 90.0626C74.2726 90.3026 74.0026 90.4627 73.7126 90.4927C73.4026 90.5327 73.1326 90.4127 72.9226 90.2127L68.9226 86.2327L62.2226 97.3327C62.0626 97.6027 61.7826 97.7726 61.4726 97.8026C61.1426 97.8426 60.8526 97.7127 60.6426 97.4827L56.8726 93.3427L51.8226 100.753C51.6426 101.013 51.3526 101.163 51.0626 101.183L51.0426 101.173Z",
			fill: "#40C676"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M284.043 18.01C283.833 18 283.623 18.0499 283.433 18.1799C282.983 18.4899 282.863 19.1 283.173 19.55L288.933 27.99C289.103 28.24 289.383 28.4001 289.683 28.4201C289.963 28.4501 290.283 28.32 290.483 28.1L294.203 24.01L300.873 35.0501C301.033 35.3101 301.293 35.48 301.593 35.52C301.893 35.55 302.193 35.45 302.413 35.24L306.463 31.21L307.5 30.1826C307.628 29.9243 307.593 29.36 307.433 29.12C307.273 28.88 307.003 28.7199 306.713 28.6899C306.403 28.6499 306.133 28.77 305.923 28.97L301.923 32.95L295.223 21.85C295.063 21.58 294.783 21.41 294.473 21.38C294.143 21.34 293.853 21.47 293.643 21.7L289.873 25.84L284.823 18.4299C284.643 18.1699 284.353 18.02 284.063 18L284.043 18.01Z",
			fill: "#40C676"
		})
	]
});
const ForwardRef = forwardRef(SvgAreasAssigned);
export default ForwardRef;
